function getDistanceFromTop (element) {
  const stickyEl = element.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return stickyEl.top + scrollTop
}

function updateStickyHeader (stickyEl, elDistanceTop, revealOnScroll) {
  if (window.pageYOffset >= elDistanceTop) {
    if (revealOnScroll) {
      stickyEl.classList.remove('tabs__navigation--hidden-until-scroll')
    } else {
      document.body.style.paddingTop = `${stickyEl.offsetHeight}px`
    }

    stickyEl.classList.add('is-sticky')
  } else {
    if (revealOnScroll) {
      stickyEl.classList.add('tabs__navigation--hidden-until-scroll')
    } else {
      document.body.style.paddingTop = 0
    }

    stickyEl.classList.remove('is-sticky')
  }
}

function initStickyHeader () {
  const stickyHeaderEl = document.querySelector('[data-toggle=sticky-header]')
  const contentEl = document.querySelector('.tabs--anchored')
  const revealOnScroll = !!document.querySelector('[data-reveal-on-scroll=true]')

  if (stickyHeaderEl) {
    const navElementDistanceTop = (revealOnScroll) ? getDistanceFromTop(contentEl) : getDistanceFromTop(stickyHeaderEl)

    updateStickyHeader(stickyHeaderEl, navElementDistanceTop, revealOnScroll)
    window.addEventListener('scroll', () => {
      updateStickyHeader(stickyHeaderEl, navElementDistanceTop, revealOnScroll)
    })
  }
}

document.addEventListener('DOMContentLoaded', initStickyHeader)

window.Carwow = window.Carwow || {}
window.Carwow.initStickyHeader = initStickyHeader
